import React, { SetStateAction, useContext, useEffect } from "react";
import { ChangeEvent, useState } from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    Snackbar,
    TextField,
    Typography,
} from "@mui/material";
import { Paper, Stack, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import {
    StyledTableHead,
    StyledTableCell,
} from "../../../Styles/tabelCellStyled/customTableCell";
import {
    CustomTextField,
    CustomThemeProvider,
} from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { Alert } from "../../../Components/Alert/Alert";
import { INecessidades } from "../../../Interfaces/anexos/anexo1/necessidades1_2";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { IPlanoNutrientes } from "../../../Interfaces/anexos/anexo1/plano_nutrientes1_3";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";


interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
    set_obj_da_tabela_3_atualizado: React.Dispatch<SetStateAction<IPlanoNutrientes | undefined>>;

}


export const NecessidadesForm: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado, set_obj_da_tabela_3_atualizado }) => {
    const auth = useContext(AuthContext);

    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [flag_editar, set_flag_editar] = useState(true);
    const [createTable, setCreateTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);
    const [obj_anexo, set_obj_anexo] = useState<INecessidades>();
    const [obj_anexo_lista, set_obj_anexo_lista] = useState<INecessidades[]>([]);
    const [error_quantidade_camp1, set_error_quantidade_camp1] = useState<boolean>(false);
    const [error_quantidade_camp2, set_error_quantidade_camp2] = useState<boolean>(false);
    const [error_quantidade_camp3, set_error_quantidade_camp3] = useState<boolean>(false);
    const [error_quantidade_camp4, set_error_quantidade_camp4] = useState<boolean>(false);
    const [error_quantidade_camp5, set_error_quantidade_camp5] = useState<boolean>(false);
    const [error_quantidade_camp6, set_error_quantidade_camp6] = useState<boolean>(false);
    const [error_quantidade_camp7, set_error_quantidade_camp7] = useState<boolean>(false);
    const [error_quantidade_camp8, set_error_quantidade_camp8] = useState<boolean>(false);
    const [existe_cabecalho, set_existe_cabecalho] = useState(false)


    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);


    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


    const handleCloseDialog = () => {
        set_obj_anexo(undefined)
        set_flag_editar(false)
        set_error_quantidade_camp1(false)
        set_error_quantidade_camp2(false)
        set_error_quantidade_camp3(false)
        set_error_quantidade_camp4(false)
        set_error_quantidade_camp5(false)
        set_error_quantidade_camp6(false)
        set_error_quantidade_camp7(false)
        set_error_quantidade_camp8(false)
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    const handle_criar_anexo = async () => {
        if (error_quantidade_camp1 || error_quantidade_camp2 || error_quantidade_camp3 || error_quantidade_camp4 || error_quantidade_camp5 || error_quantidade_camp6 || error_quantidade_camp7 || error_quantidade_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_necessidades", {
                    payload: {

                        id_necessidades: 0,
                        elemento_camp1: obj_anexo?.elemento_camp1 === undefined ? '' : obj_anexo?.elemento_camp1,
                        elemento_camp2: obj_anexo?.elemento_camp2 === undefined ? '' : obj_anexo?.elemento_camp2,
                        elemento_camp3: obj_anexo?.elemento_camp3 === undefined ? '' : obj_anexo?.elemento_camp3,
                        elemento_camp4: obj_anexo?.elemento_camp4 === undefined ? '' : obj_anexo?.elemento_camp4,
                        quantidade_camp1: obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1,
                        quantidade_camp2: obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2,
                        quantidade_camp3: obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3,
                        quantidade_camp4: obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4,
                        quantidade_camp5: obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5,
                        quantidade_camp6: obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6,
                        quantidade_camp7: obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7,
                        quantidade_camp8: obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8,
                        tabela: obj_anexo?.tabela === undefined ? '' : obj_anexo?.tabela,
                        origem: obj_anexo?.origem === undefined ? false : obj_anexo?.origem,
                        origem_b: obj_anexo?.origem_b === undefined ? false : obj_anexo?.origem_b,
                        tabela_b: obj_anexo?.tabela_b === undefined ? '' : obj_anexo?.tabela_b,

                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista([data.data.result[0]])
                    set_obj_da_tabela_3_atualizado(data.data.result[1])
                    set_flag_editar(false)
                    set_obj_anexo(undefined)
                    setCreateTable(false)
                    set_flag_editado(false)

                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }


    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        set_flag_editado(true)

        if (type === "checkbox") {
            set_obj_anexo((prev: any) => {
                return {
                    ...prev,
                    [name]: checked,
                };
            });
        } else {

            if (name === 'quantidade_camp1') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp1(true)
                } else {
                    set_error_quantidade_camp1(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp2') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp2(true)
                } else {
                    set_error_quantidade_camp2(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp3') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp3(true)
                } else {
                    set_error_quantidade_camp3(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp4') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp4(true)
                } else {
                    set_error_quantidade_camp4(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp5') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp5(true)
                } else {
                    set_error_quantidade_camp5(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp6') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp6(true)
                } else {
                    set_error_quantidade_camp6(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp7') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp7(true)
                } else {
                    set_error_quantidade_camp7(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else if (name === 'quantidade_camp8') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_quantidade_camp8(true)
                } else {
                    set_error_quantidade_camp8(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }


        }


    };

    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_necessidades/${obj_anexo?.id_necessidades}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.filter((el) => {
                    if (el.id_necessidades !== obj_anexo?.id_necessidades) {
                        return el
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    setCreateTable(true)
                }
                set_obj_da_tabela_3_atualizado(res.data.result)

                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };

    const handle_update_anexo = async () => {
        if (error_quantidade_camp1 || error_quantidade_camp2 || error_quantidade_camp3 || error_quantidade_camp4 || error_quantidade_camp5 || error_quantidade_camp6 || error_quantidade_camp7 || error_quantidade_camp8) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, "update_reg_anexo_um_necessidades", { payload: obj_anexo });

                if (res.status === 200) {
                    let lista_aux: any = obj_anexo_lista?.map((el) => {
                        if (el.id_necessidades !== obj_anexo?.id_necessidades) {
                            return el
                        } else {
                            return res.data.result[0]
                        }
                    })
                    set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                    set_obj_anexo(undefined);
                    set_obj_da_tabela_3_atualizado(res.data.result[1])
                    set_flag_editar(false)
                    set_flag_editado(false)
                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                } else {
                    setMessage("Erro ao gravar!");

                    setOpenSnackError(true);
                }

                setIsLoading(false);
            } catch (error) {
                func_print("handle_update_anexo", error, true);
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    };

    const handleCloseSnack = () => {

        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };

    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_necessidades_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );

            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_anexo_lista(res.data.result);
                } else {
                    setCreateTable(true)
                    set_flag_editar(false)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();
                set_existe_cabecalho(true)
                set_flag_editar(false)

            } else {
                set_existe_cabecalho(false)
                set_obj_anexo_lista([]);
                set_flag_editar(true)


            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);


    return (
        <>
            <CustomThemeProvider>
                {isLoading ? (
                    <LoadingVulpes />
                ) : (
                    <TableContainer
                        component={Paper}
                        variant="outlined"
                        sx={{
                            height: "auto",
                            width: "auto",
                            margin: 2,
                            padding: 2,
                        }}
                    >
                        <Snackbar
                            open={openSnackSuccess}
                            autoHideDuration={2000}
                            onClose={handleCloseSnack}
                        >
                            <Alert
                                onClose={handleCloseSnack}
                                severity="success"
                                sx={{ width: "100%" }}
                            >
                                {message}
                            </Alert>
                        </Snackbar>
                        <Snackbar
                            open={openSnackError}
                            autoHideDuration={2000}
                            onClose={handleCloseSnack}
                        >
                            <Alert
                                onClose={handleCloseSnack}
                                severity="error"
                                sx={{ width: "100%" }}
                            >
                                {message}
                            </Alert>
                        </Snackbar>
                        <table style={{ width: "100%" }}>
                            <TableHead>
                                <TableRow>
                                    {
                                        obj_anexo_lista.length !== 0 ?
                                            <></>
                                            :
                                            <>
                                                <TableCell
                                                    colSpan={8}
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: 18,
                                                        textAlign: "left",
                                                        fontFamily: "candara",
                                                    }}
                                                >
                                                    2 - Necessidades da cultura
                                                </TableCell>
                                                {
                                                    existe_cabecalho === false ? <></> :
                                                        createTable === false ?
                                                            <TableCell>
                                                                <Stack direction="row" justifyContent="end">
                                                                    {is_historico === true ? <></> :

                                                                        <BarraDeFerramentas
                                                                            mostrarBotaoNovo
                                                                            textoBotaoNovo="Registar"
                                                                            aoClicarNovo={() => {
                                                                                set_obj_anexo(undefined)

                                                                                setCreateTable(true)
                                                                            }}
                                                                        />}
                                                                </Stack>
                                                            </TableCell>
                                                            :
                                                            <TableCell>
                                                                {is_historico === true ? <></> :

                                                                    <ButtonCadernos
                                                                        // mostrarBotaoCancelar
                                                                        // aoClicarCancelar={() => {
                                                                        //     set_obj_anexo(undefined)
                                                                        //     setCreateTable(false)
                                                                        // }}
                                                                        mostrarBotaoGravar
                                                                        aoClicarGravar={() => { handle_criar_anexo() }}
                                                                    />}
                                                            </TableCell>
                                                }

                                            </>

                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>


                                {createTable && (
                                    <>
                                        <TableRow>
                                            <StyledTableHead>Elemento</StyledTableHead>
                                            <StyledTableHead>N</StyledTableHead>
                                            <StyledTableHead>P2O5</StyledTableHead>
                                            <StyledTableHead>K2O</StyledTableHead>
                                            <StyledTableHead>Mg</StyledTableHead>
                                            <StyledTableHead>
                                                <CustomTextField
                                                    name="elemento_camp1"
                                                    value={obj_anexo?.elemento_camp1 === undefined ? '' : obj_anexo?.elemento_camp1}
                                                    onChange={onInputChange}
                                                />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                <CustomTextField
                                                    name="elemento_camp2"
                                                    value={obj_anexo?.elemento_camp2 === undefined ? '' : obj_anexo?.elemento_camp2}
                                                    onChange={onInputChange}
                                                />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                <CustomTextField
                                                    name="elemento_camp3"
                                                    value={obj_anexo?.elemento_camp3 === undefined ? '' : obj_anexo?.elemento_camp3}
                                                    onChange={onInputChange}
                                                />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                <CustomTextField
                                                    name="elemento_camp4"
                                                    value={obj_anexo?.elemento_camp4 === undefined ? '' : obj_anexo?.elemento_camp4}
                                                    onChange={onInputChange}
                                                />
                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead>Quantidade (mg/kg)</StyledTableHead>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp1"
                                                    value={obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp1}
                                                    helperText={error_quantidade_camp1 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp2"
                                                    value={obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp2}
                                                    helperText={error_quantidade_camp2 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp3"
                                                    value={obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp3}
                                                    helperText={error_quantidade_camp3 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp4"
                                                    value={obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp4}
                                                    helperText={error_quantidade_camp4 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp5"
                                                    value={obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp5}
                                                    helperText={error_quantidade_camp5 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp6"
                                                    value={obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp6}
                                                    helperText={error_quantidade_camp6 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp7"
                                                    value={obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp7}
                                                    helperText={error_quantidade_camp7 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <CustomTextField
                                                    name="quantidade_camp8"
                                                    value={obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8.toString().replace('.', ',')}
                                                    onChange={onInputChange}
                                                    error={error_quantidade_camp8}
                                                    helperText={error_quantidade_camp8 ? "Apenas números são aceites" : ""}
                                                />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell
                                                rowSpan={2}
                                                colSpan={3}
                                                sx={{
                                                    textAlign: "left",
                                                    fontWeight: 600,
                                                    fontFamily: "candara",
                                                }}
                                            >
                                                <Stack direction="row" justifyContent="center">
                                                    Origem dos dados:
                                                    <Box margin={-1} padding={0}>
                                                        <BasicPopover
                                                            text={
                                                                "Assinalar com uma X o campo correspondente à origem dos dados"
                                                            }
                                                        />
                                                    </Box>
                                                </Stack>
                                            </TableCell>
                                            <TableCell colSpan={3}>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="left"
                                                >
                                                    <FormControlLabel
                                                        name="origem"
                                                        label={
                                                            <Typography fontFamily="candara" fontSize={16}>
                                                                a) Tabela - Referência bibliográfica:
                                                            </Typography>
                                                        }
                                                        aria-readonly
                                                        control={
                                                            <Checkbox
                                                                checked={!!obj_anexo?.origem}
                                                                onChange={onInputChange}
                                                                name="origem"
                                                                disabled={!!flag_editar}
                                                                sx={{
                                                                    color: "#aaaaaa",
                                                                    "&.Mui-checked": {
                                                                        color: "#C94F1E",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </Stack>
                                            </TableCell>
                                            <TableCell colSpan={3}>
                                                <CustomTextField
                                                    name="tabela"
                                                    value={obj_anexo?.tabela}
                                                    onChange={onInputChange}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="left"
                                                >
                                                    <FormControlLabel
                                                        name="origem_b"
                                                        label={
                                                            <Typography fontFamily="candara" fontSize={16}>
                                                                b) Análise - Data:
                                                            </Typography>
                                                        }
                                                        aria-readonly
                                                        control={
                                                            <Checkbox
                                                                checked={!!obj_anexo?.origem_b}
                                                                onChange={onInputChange}
                                                                name="origem_b"
                                                                disabled={!!flag_editar}
                                                                sx={{
                                                                    color: "#aaaaaa",
                                                                    "&.Mui-checked": {
                                                                        color: "#C94F1E",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                    />
                                                </Stack>
                                            </TableCell>

                                            <TableCell colSpan={3}>
                                                <TextField
                                                    variant="filled"
                                                    type="date"
                                                    inputProps={{
                                                        style: { fontSize: 12, fontFamily: "verdana" },
                                                    }}
                                                    name="tabela_b"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    value={
                                                        obj_anexo?.tabela_b ? obj_anexo?.tabela_b : ""
                                                    }
                                                    onChange={onInputChange}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}

                                {obj_anexo_lista?.map((tab) => {
                                    if (tab.id_necessidades === obj_anexo?.id_necessidades) {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={8}
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: 18,
                                                            textAlign: "left",
                                                            fontFamily: "candara",
                                                        }}
                                                    >
                                                        2 - Necessidades da cultura
                                                    </TableCell>

                                                    <ButtonCadernos
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => { handle_update_anexo() }}
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                set_obj_anexo(undefined)
                                                                set_flag_editar(false)
                                                            }

                                                        }}
                                                    />

                                                </TableRow>

                                                <TableRow>
                                                    <StyledTableHead>Nutriente </StyledTableHead>
                                                    <StyledTableHead>N</StyledTableHead>
                                                    <StyledTableHead>P2O5</StyledTableHead>
                                                    <StyledTableHead>K2O</StyledTableHead>
                                                    <StyledTableHead>Mg</StyledTableHead>
                                                    <StyledTableHead>
                                                        <CustomTextField
                                                            name="elemento_camp1"
                                                            value={obj_anexo?.elemento_camp1 === undefined ? '' : obj_anexo?.elemento_camp1}
                                                            onChange={onInputChange}
                                                        />
                                                    </StyledTableHead>
                                                    <StyledTableHead>
                                                        <CustomTextField
                                                            name="elemento_camp2"
                                                            value={obj_anexo?.elemento_camp2 === undefined ? '' : obj_anexo?.elemento_camp2}
                                                            onChange={onInputChange}
                                                        />
                                                    </StyledTableHead>
                                                    <StyledTableHead>
                                                        <CustomTextField
                                                            name="elemento_camp3"
                                                            value={obj_anexo?.elemento_camp3 === undefined ? '' : obj_anexo?.elemento_camp3}
                                                            onChange={onInputChange}
                                                        />
                                                    </StyledTableHead>
                                                    <StyledTableHead>
                                                        <CustomTextField
                                                            name="elemento_camp4"
                                                            value={obj_anexo?.elemento_camp4 === undefined ? '' : obj_anexo?.elemento_camp4}
                                                            onChange={onInputChange}
                                                        />
                                                    </StyledTableHead>
                                                </TableRow>
                                                <TableRow>
                                                    <StyledTableHead>
                                                        Quantidade (mg/kg)
                                                    </StyledTableHead>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp1"
                                                            value={obj_anexo?.quantidade_camp1 === undefined ? '' : obj_anexo?.quantidade_camp1.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp1}
                                                            helperText={error_quantidade_camp1 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp2"
                                                            value={obj_anexo?.quantidade_camp2 === undefined ? '' : obj_anexo?.quantidade_camp2.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp2}
                                                            helperText={error_quantidade_camp2 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp3"
                                                            value={obj_anexo?.quantidade_camp3 === undefined ? '' : obj_anexo?.quantidade_camp3.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp3}
                                                            helperText={error_quantidade_camp3 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp4"
                                                            value={obj_anexo?.quantidade_camp4 === undefined ? '' : obj_anexo?.quantidade_camp4.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp4}
                                                            helperText={error_quantidade_camp4 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp5"
                                                            value={obj_anexo?.quantidade_camp5 === undefined ? '' : obj_anexo?.quantidade_camp5.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp5}
                                                            helperText={error_quantidade_camp5 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp6"
                                                            value={obj_anexo?.quantidade_camp6 === undefined ? '' : obj_anexo?.quantidade_camp6.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp6}
                                                            helperText={error_quantidade_camp6 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp7"
                                                            value={obj_anexo?.quantidade_camp7 === undefined ? '' : obj_anexo?.quantidade_camp7.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp7}
                                                            helperText={error_quantidade_camp7 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="quantidade_camp8"
                                                            value={obj_anexo?.quantidade_camp8 === undefined ? '' : obj_anexo?.quantidade_camp8.toString().replace('.', ',')}
                                                            onChange={onInputChange}
                                                            error={error_quantidade_camp8}
                                                            helperText={error_quantidade_camp8 ? "Apenas números são aceites" : ""}
                                                        />
                                                    </StyledTableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell
                                                        rowSpan={2}
                                                        sx={{
                                                            textAlign: "left",
                                                            fontWeight: 600,
                                                            fontFamily: "candara",
                                                        }}
                                                    >
                                                        <Stack direction="row" justifyContent="center">
                                                            Origem dos dados:
                                                            <Box margin={-1} padding={0}>
                                                                <BasicPopover
                                                                    text={
                                                                        "Assinalar com uma X o campo correspondente à origem dos dados"
                                                                    }
                                                                />
                                                            </Box>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell colSpan={2}>
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="left"
                                                        >
                                                            <FormControlLabel
                                                                name="origem"
                                                                label={
                                                                    <Typography
                                                                        fontFamily="candara"
                                                                        fontSize={16}
                                                                    >
                                                                        a) Tabela - Referência bibliográfica:
                                                                    </Typography>
                                                                }
                                                                aria-readonly
                                                                control={
                                                                    <Checkbox
                                                                        checked={!!obj_anexo?.origem}
                                                                        onChange={onInputChange}
                                                                        name="origem"
                                                                        disabled={!flag_editar}
                                                                        sx={{
                                                                            color: "#aaaaaa",
                                                                            "&.Mui-checked": {
                                                                                color: "#C94F1E",
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell colSpan={2}>
                                                        <CustomTextField
                                                            name="tabela"
                                                            value={obj_anexo?.tabela === undefined ? '' : obj_anexo?.tabela}
                                                            onChange={onInputChange}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell colSpan={2}>
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="left"
                                                        >
                                                            <FormControlLabel
                                                                name="origem_b"
                                                                label={
                                                                    <Typography
                                                                        fontFamily="candara"
                                                                        fontSize={16}
                                                                    >
                                                                        b) Análise - Data:
                                                                    </Typography>
                                                                }
                                                                aria-readonly
                                                                control={
                                                                    <Checkbox
                                                                        checked={!!obj_anexo?.origem_b}
                                                                        onChange={onInputChange}
                                                                        name="origem_b"
                                                                        disabled={!flag_editar}
                                                                        sx={{
                                                                            color: "#aaaaaa",
                                                                            "&.Mui-checked": {
                                                                                color: "#C94F1E",
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        </Stack>
                                                    </TableCell>

                                                    <TableCell colSpan={2}>
                                                        <TextField
                                                            variant="filled"
                                                            type="date"
                                                            inputProps={{
                                                                style: {
                                                                    fontSize: 12,
                                                                    fontFamily: "verdana",
                                                                },
                                                            }}
                                                            name="tabela_b"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            value={obj_anexo?.tabela_b === undefined ? '' : obj_anexo?.tabela_b}
                                                            onChange={onInputChange}
                                                        />
                                                    </TableCell>
                                                </TableRow>

                                            </>
                                        );
                                    } else {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={8}
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: 18,
                                                            textAlign: "left",
                                                            fontFamily: "candara",
                                                        }}
                                                    >
                                                        2 - Necessidades da cultura
                                                    </TableCell>
                                                    <TableCell>
                                                        {is_historico === true ? <></> :

                                                            <ButtonCadernos
                                                                mostrarBotaoEditar
                                                                aoClicarEditar={() => {
                                                                    setCreateTable(false)
                                                                    set_obj_anexo(tab)
                                                                    set_flag_editar(true)
                                                                }}
                                                                mostrarBotaoApagar
                                                                aoClicarApagar={() => {
                                                                    set_obj_anexo(tab)
                                                                    set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                                }}
                                                            />}
                                                    </TableCell>

                                                </TableRow>

                                                <TableRow>
                                                    <StyledTableHead>Nutriente </StyledTableHead>
                                                    <StyledTableHead>N</StyledTableHead>
                                                    <StyledTableHead>P2O5</StyledTableHead>
                                                    <StyledTableHead>K2O</StyledTableHead>
                                                    <StyledTableHead>Mg</StyledTableHead>
                                                    <StyledTableHead>
                                                        {tab.elemento_camp1}
                                                    </StyledTableHead>
                                                    <StyledTableHead>
                                                        {tab.elemento_camp2}
                                                    </StyledTableHead>
                                                    <StyledTableHead>
                                                        {tab.elemento_camp3}
                                                    </StyledTableHead>
                                                    <StyledTableHead>
                                                        {tab.elemento_camp4}
                                                    </StyledTableHead>
                                                </TableRow>
                                                <TableRow>
                                                    <StyledTableHead>
                                                        Quantidade (mg/kg)
                                                    </StyledTableHead>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp1.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp2.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp3.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp4.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp5.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp6.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp7.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {tab.quantidade_camp8.toString().replace('.', ',')}
                                                    </StyledTableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell
                                                        rowSpan={2}
                                                        colSpan={3}
                                                        sx={{
                                                            textAlign: "left",
                                                            fontWeight: 600,
                                                            fontFamily: "candara",
                                                        }}
                                                    >
                                                        <Stack direction="row" justifyContent="center">
                                                            Origem dos dados:
                                                            <Box margin={-1} padding={0}>
                                                                <BasicPopover
                                                                    text={
                                                                        "Assinalar com uma X o campo correspondente à origem dos dados"
                                                                    }
                                                                />
                                                            </Box>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell colSpan={3}>
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="left"
                                                        >
                                                            <FormControlLabel
                                                                name="origem"
                                                                label={
                                                                    <Typography
                                                                        fontFamily="candara"
                                                                        fontSize={16}
                                                                    >
                                                                        a) Tabela - Referência bibliográfica:
                                                                    </Typography>
                                                                }
                                                                aria-readonly
                                                                control={
                                                                    <Checkbox
                                                                        checked={!!tab.origem}
                                                                        onChange={onInputChange}
                                                                        name="origem"
                                                                        disabled={!flag_editar}
                                                                        sx={{
                                                                            color: "#aaaaaa",
                                                                            "&.Mui-checked": {
                                                                                color: "#C94F1E",
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell colSpan={3}>{tab.tabela}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell colSpan={3}>
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="left"
                                                        >
                                                            <FormControlLabel
                                                                name="origem_b"
                                                                label={
                                                                    <Typography
                                                                        fontFamily="candara"
                                                                        fontSize={16}
                                                                    >
                                                                        b) Análise - Data:
                                                                    </Typography>
                                                                }
                                                                aria-readonly
                                                                control={
                                                                    <Checkbox
                                                                        checked={!!tab.origem_b}
                                                                        onChange={onInputChange}
                                                                        name="origem_b"
                                                                        disabled={!flag_editar}
                                                                        sx={{
                                                                            color: "#aaaaaa",
                                                                            "&.Mui-checked": {
                                                                                color: "#C94F1E",
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        </Stack>
                                                    </TableCell>

                                                    <TableCell colSpan={3}>{tab.tabela_b}</TableCell>
                                                </TableRow>

                                            </>
                                        );
                                    }
                                })}
                            </TableBody>
                        </table>
                    </TableContainer>
                )}
                <ConfirmDialog
                    open={open_dialog_tem_a_certeza_que_quer_eliminar}
                    onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                    onConfirm={handle_delete_anexo}
                    message="Deseja eliminar o registo?"
                />
                <ConfirmDialog
                    open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                    onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                    onConfirm={() => handleCloseDialog()}
                    message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                />
            </CustomThemeProvider>
        </>
    );
};